<template>
  <form @submit.prevent.stop="handleSubmitForm">
    <div class="pt-3 pl-2 pr-0">
      <div class="d-flex">
        <div
          class="form-group mr-5 mt-1"
          v-for="item in translationSelectByDateOrYears()"
          :key="item.id"
          >
          <div class="form-check pl-0 pr-5">
            <label
              class="form-check-label pointer-clickable"
            >
              {{ item.name }}
            </label>
            <input
              v-model="selectedDateOrYears"
              class="form-check-input pointer-clickable ml-2"
              type="radio"
              :value="item.value"
              @change="changeRevenueAndProfitFilterType"
            />
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center mb-2">
        <div class="card-label mr-2">{{ translations('common.period') }}</div>

        <div class="flex-grow-1">
          <DatePicker
            v-model="dateRange"
            value-type="format"
            format="YYYY/MM/DD"
            placeholder="yyyy/mm/dd ~ yyyy/mm/dd"
            class="date-range-field"
            range
            :editable="false"
            :clearable="false"
            :disabled="!!selectedDateOrYears"
          />
        </div>
      </div>
      <div class="d-flex align-items-center mb-2">
        <div class="card-label mr-2">{{ translations('dashboard.period') }}</div>
        <div class="dropdown">
          <button
            class="btn btn-outline-secondary dropdown-toggle"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            :disabled="!selectedDateOrYears"
          >
            {{ selectedYear }}
          </button>
          <div class="dropdown-menu dropdown-month">
            <a
              v-for="yearOption in years"
              :key="yearOption.value"
              class="dropdown-item"
              @click="selectYear(yearOption)"
            >
              {{ yearOption.name }}
            </a>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center mb-2">
        <div class="card-label mr-2">{{ translations('dashboard.department') }}</div>
        <div class="dropdown">
          <button
            class="btn btn-outline-secondary dropdown-toggle"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{ department }}
          </button>
          <div class="dropdown-menu dropdown-month">
            <a
              v-for="depart in departments"
              :key="depart"
              class="dropdown-item"
              @click="selectDepartment(depart)"
            >
              {{ depart }}
            </a>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center mb-2">
        <div class="card-label mr-2">{{ translations('dashboard.unit_1') }}</div>
        <div class="dropdown mr-2">
          <button
            class="btn btn-outline-secondary dropdown-toggle"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{ selectedUnit1 }}
          </button>
          <div class="dropdown-menu dropdown-month">
            <a
              class="dropdown-item"
              v-for="unit in translatedUnits"
              :key="unit.id"
              @click="selectUnitOne(unit.id)"
            >
              {{ unit.name }}
            </a>
          </div>
        </div>
      </div>
      <div class="mb-2 multiselect__wrap">
        <template v-if="unit1Id === 'category'">
          <multiselect
            v-model="valueUnitOne"
            :options="categoriesUnitOne"
            :multiple="true"
            group-values="libs"
            group-label="name"
            :group-select="true"
            track-by="id"
            label="name"
            :placeholder="translations('dashboard.search_type')"
            selectLabel=""
            :selectedLabel="translations('dashboard.selected')"
            selectGroupLabel=""
            deselectLabel=""
            deselectGroupLabel=""
            :closeOnSelect="false"
            :showPointer="!isHoverSelectAllUnitOne"
            class="custom-multiselect"
          >
            <li
              class="multiselect__element"
              slot="beforeList"
              @mouseover="isHoverSelectAllUnitOne = true"
              @mouseout="isHoverSelectAllUnitOne = false"
              @click="selectAllUnitOne"
            >
              <span
                class="multiselect__option multiselect__option--group"
                :class="{
                  'multiselect__option--highlight': isHoverSelectAllUnitOne,
                  'multiselect__option--group-selected': isSelectedAllOne
                }">{{ translations('dashboard.all') }}</span>
            </li>
            <span slot="noResult">{{ translations('dashboard.item_not_found') }} </span>
          </multiselect>
        </template>
        <template v-if="unit1Id === 'customer' || unit1Id === 'employee'">
          <multiselect
            v-model="valueUnitOne"
            :options="
              customersUnitOne.length ? customersUnitOne : personInChargeOne
            "
            :multiple="true"
            track-by="id"
            :label="unit1Id === 'customer' ? 'company' : 'name'"
            :group-select="true"
            group-values="libs"
            group-label="name"
            :placeholder="translations('dashboard.search_type')"
            selectLabel=""
            :selectedLabel="translations('dashboard.selected')"
            selectGroupLabel=""
            deselectLabel=""
            deselectGroupLabel=""
            :closeOnSelect="false"
            class="custom-multiselect"
          >
            <span slot="noResult">{{ translations('dashboard.item_not_found') }}</span>
          </multiselect>
        </template>
      </div>
      <div class="d-flex align-items-center mb-2">
        <div class="card-label mr-2">{{ translations('dashboard.unit_2') }}</div>
        <div class="dropdown mr-2">
          <button
            class="btn btn-outline-secondary dropdown-toggle"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{ selectedUnit2 }}
          </button>
          <div class="dropdown-menu dropdown-month">
            <a
              class="dropdown-item"
              v-for="unit in filteredUnitsTwo"
              :key="unit.id"
              @click="selectUnitTwo(unit.id)"
            >
              {{ unit.name }}
            </a>
          </div>
        </div>
      </div>
      <div class="mb-2 multiselect__wrap">
        <template v-if="unit2Id === 'category'">
          <multiselect
            v-model="valueUnitTwo"
            :options="categoriesUnitTwo"
            :multiple="true"
            group-values="libs"
            group-label="name"
            :group-select="true"
            track-by="id"
            label="name"
            :placeholder="translations('dashboard.search_type')"
            selectLabel=""
            :selectedLabel="translations('dashboard.selected')"
            selectGroupLabel=""
            deselectLabel=""
            deselectGroupLabel=""
            :closeOnSelect="false"
            :showPointer="!isHoverSelectAllUnitTwo"
            class="custom-multiselect"
          >
            <li
              class="multiselect__element"
              slot="beforeList"
              @mouseover="isHoverSelectAllUnitTwo = true"
              @mouseout="isHoverSelectAllUnitTwo = false"
              @click="selectAllUnitTwo"
            >
              <span
                class="multiselect__option multiselect__option--group"
                :class="{
                  'multiselect__option--highlight': isHoverSelectAllUnitTwo,
                  'multiselect__option--group-selected': isSelectedAllTwo
                }">{{ translations('dashboard.all') }}</span>
            </li>
            <span slot="noResult">{{ translations('dashboard.item_not_found') }}</span>
          </multiselect>
        </template>
        <template v-if="unit2Id === 'customer' || unit2Id === 'employee'">
          <multiselect
            v-model="valueUnitTwo"
            :options="
              customersUnitTwo.length ? customersUnitTwo : personInChargeTwo
            "
            :multiple="true"
            track-by="id"
            :label="unit2Id === 'customer' ? 'company' : 'name'"
            :group-select="true"
            group-values="libs"
            group-label="name"
            :placeholder="translations('dashboard.search_type')"
            selectLabel=""
            :selectedLabel="translations('dashboard.selected')"
            selectGroupLabel=""
            deselectLabel=""
            deselectGroupLabel=""
            :closeOnSelect="false"
            class="custom-multiselect"
          >
            <span slot="noResult">{{ translations('dashboard.item_not_found') }} </span>
          </multiselect>
        </template>
      </div>
      <v-row class="justify-content-center">
        <button class="btn btn-outline-secondary mt-3" type="submit">
          {{ translations('dashboard.display_dashboard') }}
        </button>
      </v-row>
      <vue-element-loading :active="isSearching" />
    </div>
  </form>
</template>

<script>
import Multiselect from 'vue-multiselect'
import VueElementLoading from 'vue-element-loading'
import isEqual from 'lodash/isEqual'
import differenceWith from 'lodash/differenceWith'
import throttle from 'lodash/throttle'
import { startOfYear, endOfYear, getTime } from 'date-fns'

import DatePicker from '@/components/common/DatePicker'

import { RevenueAndProfitFilterType } from '@/constants'
import { mapState } from 'vuex'

export default {
  name: 'RevenueAndProfitChartFilter',
  components: {
    Multiselect,
    VueElementLoading,
    DatePicker
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    year (val) {
      let params = this.$session.get('ChartFilterParam') || {}
      params.year = val
      this.$session.set('ChartFilterParam', params)
    },

    department (val) {
      let params = this.$session.get('ChartFilterParam') || {}
      params.department = val
      this.$session.set('ChartFilterParam', params)
    },

    unit1Id (val) {
      let params = this.$session.get('ChartFilterParam') || {}
      params.unit1Id = val
      this.$session.set('ChartFilterParam', params)
    },

    unit2Id (val) {
      let params = this.$session.get('ChartFilterParam') || {}
      params.unit2Id = val
      this.$session.set('ChartFilterParam', params)
    },

    dateRange (val) {
      let params = this.$session.get('ChartFilterParam') || {}
      params.dateRange = val
      this.$session.set('ChartFilterParam', params)
    },

    selectedDateOrYears (val) {
      let params = this.$session.get('ChartFilterParam') || {}
      params.selectedDateOrYears = val
      this.$session.set('ChartFilterParam', params)
    }
  },
  async created () {
    this.isSearching = true

    window.addEventListener('unload', this.saveValueUnit)

    let storedUnitOne = this.$session.get('ChartFilter:valueUnitOne')
    let storedUnitTwo = this.$session.get('ChartFilter:valueUnitTwo')

    if (this.unit1Id) {
      await this.selectUnitOne(this.unit1Id)
    }

    if (this.unit2Id) {
      await this.selectUnitTwo(this.unit2Id)
    }

    this.valueUnitOne = storedUnitOne || []
    this.valueUnitTwo = storedUnitTwo || []

    this.fireSearch()

    this.isSearching = false
  },
  beforeDestroy: function () {
    window.removeEventListener('unload', this.saveValueUnit)
  },
  data () {
    const units = [
      { id: 'category', name: 'カテゴリ' },
      { id: 'customer', name: '顧客' },
      { id: 'employee', name: '担当者' }
    ]
    const [{ id: defaultUnit1Id }, { id: defaultUnit2Id }] = units
    const {
      dateRange,
      year = new Date().getFullYear(),
      department = '外販',
      unit1Id = defaultUnit1Id,
      unit2Id = defaultUnit2Id,
      selectedDateOrYears = 0
    } = this.$session.get('ChartFilterParam') || {}

    return {
      isSearching: false,
      isHoverSelectAllUnitOne: false,
      isHoverSelectAllUnitTwo: false,
      getDifCategoryOne: [],
      year,
      department,
      unit1Id,
      unit2Id,
      valueUnitOne: [],
      valueUnitTwo: [],
      customersUnitOne: [],
      customersUnitTwo: [],
      personInChargeOne: [],
      personInChargeTwo: [],
      categoriesUnitOne: [],
      categoriesUnitTwo: [],
      units,
      years: [
        { name: '今期', value: new Date().getFullYear() },
        { name: '前期', value: new Date().getFullYear() - 1 },
        { name: '前々期', value: new Date().getFullYear() - 2 }
      ],
      departments: ['全て', '外販', 'EC', 'コストコ'],
      selectedDateOrYears,
      selectByDateOrYears: [
        { id: 'date', name: 'カレンダー', value: RevenueAndProfitFilterType.date },
        { id: 'year', name: '期', value: RevenueAndProfitFilterType.year }
      ],
      dateRange: dateRange || this.generateDateRangeByYear(year),
      limit: 10000,
      page: 1,
      search: false
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    filteredUnitsTwo () {
      return this.units.filter((u) => u.id !== this.unit1Id).map(unit => {
        return {
          ...unit,
          name: this.translations(`dashboard.${unit.id}`)
        }
      })
    },
    selectedYear () {
      return this.years.find(({ value }) => value === this.year).name
    },
    selectedUnit1 () {
      return this.translations(`units.${this.units.find(({ id }) => id === this.unit1Id).name}`)
    },
    selectedUnit2 () {
      return this.filteredUnitsTwo.find(({ id }) => id === this.unit2Id).name
    },
    isSelectedAllOne () {
      if (!this.valueUnitOne.length) return false
      return !differenceWith(this.getAllUnitWithFilter(this.unit1Id, 1), this.valueUnitOne, isEqual).length
    },
    isSelectedAllTwo () {
      if (!this.valueUnitTwo.length) return false
      return !differenceWith(this.getAllUnitWithFilter(this.unit2Id, 2), this.valueUnitTwo, isEqual).length
    },
    translatedUnits () {
      return this.units.map(unit => {
        return {
          ...unit,
          name: this.translations(`dashboard.${unit.id}`)
        }
      })
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },

    disableDateRange (current) {
      const firstDateOfYearTimestamp = getTime(this.firstDateOfYear(this.year))
      const lastDateOfYearTimestamp = getTime(this.lastDateOfYear(this.year))
      const currentDateTimestamp = current && current.valueOf()

      return firstDateOfYearTimestamp > currentDateTimestamp || lastDateOfYearTimestamp < currentDateTimestamp
    },

    saveValueUnit () {
      this.$session.set('ChartFilter:valueUnitOne', this.valueUnitOne)
      this.$session.set('ChartFilter:valueUnitTwo', this.valueUnitTwo)
    },

    async selectUnitOne (unitId) {
      this.isSearching = true
      if (this.currentLanguage === 'en') {

      }
      const params = {
        limit: this.limit,
        page: this.page,
        search: this.department === this.translations('departments.全て') ? null : this.department
      }
      switch (unitId) {
        case 0:
          this.customersUnitOne = []
          this.personInChargeOne = []
          this.valueUnitOne = []
          this.categoriesUnitOne = []
          break
        case 'category':
          try {
            const response = await this.$http.get(this.$api_url.categories)
            const { data, success } = response.data
            if (success) {
              this.categoriesUnitOne = data
              this.personInChargeOne = []
              this.customersUnitOne = []
              this.valueUnitOne = []
            }
          } catch (error) {}
          this.unit1Id = unitId
          this.unit2Id = this.filteredUnitsTwo[0].id
          this.selectUnitTwo(this.unit2Id)
          break
        case 'customer':
          try {
            const response = await this.$http.get(this.$api_url.customers, { params })
            const { data, success } = response.data
            let newData = data.filter(function (obj) {
              return obj.shintaro_hidden_dashboard !== '1'
            })
            if (success) {
              this.customersUnitOne = [this.formatUnit(newData)]
              this.personInChargeOne = []
              this.valueUnitOne = []
              this.categoriesUnitOne = []
            }
          } catch (error) {}
          this.unit1Id = unitId
          this.unit2Id = this.filteredUnitsTwo[0].id
          this.selectUnitTwo(this.unit2Id)
          break
        case 'employee':
          try {
            const response = await this.$http.get(this.$api_url.personel, { params })
            const { data, success } = response.data
            if (success) {
              this.personInChargeOne = [this.formatUnit(data)]
              this.customersUnitOne = []
              this.valueUnitOne = []
              this.categoriesUnitOne = []
            }
          } catch (error) {}
          this.unit1Id = unitId
          this.unit2Id = this.filteredUnitsTwo[0].id
          this.selectUnitTwo(this.unit2Id)
          break
      }
      this.isSearching = false
    },

    async selectUnitTwo (unitId) {
      this.isSearching = true
      const params = {
        limit: this.limit,
        page: this.page,
        search: this.department === '全て' ? null : this.department
      }
      switch (unitId) {
        case 0:
          this.categoriesUnitTwo = []
          this.personInChargeTwo = []
          this.valueUnitTwo = []
          this.customersUnitTwo = []
          break
        case 'category':
          try {
            const response = await this.$http.get(this.$api_url.categories)
            const { data, success } = response.data
            if (success) {
              this.categoriesUnitTwo = data
              this.personInChargeTwo = []
              this.valueUnitTwo = []
              this.customersUnitTwo = []
            }
          } catch (error) {}
          this.unit2Id = unitId
          break
        case 'customer':
          try {
            const response = await this.$http.get(this.$api_url.customers, { params })
            const { data, success } = response.data
            let newData = data.filter(function (obj) {
              return obj.shintaro_hidden_dashboard !== '1'
            })
            if (success) {
              this.customersUnitTwo = [this.formatUnit(newData)]
              this.personInChargeTwo = []
              this.valueUnitTwo = []
              this.categoriesUnitTwo = []
            }
          } catch (error) {}
          this.unit2Id = unitId
          break
        case 'employee':
          try {
            const response = await this.$http.get(this.$api_url.personel, { params })
            const { data, success } = response.data
            if (success) {
              this.personInChargeTwo = [this.formatUnit(data)]
              this.customersUnitTwo = []
              this.valueUnitTwo = []
              this.categoriesUnitTwo = []
            }
          } catch (error) {}
          this.unit2Id = unitId
          break
      }
      this.isSearching = false
    },

    fireSearch () {
      const payload = {
        unit_1: {
          key: this.unit1Id,
          value: this.isSelectedAllOne ? [] : this.valueUnitOne.map(({ id }) => id)
        },
        unit_2: {
          key: this.unit2Id,
          value: this.isSelectedAllTwo ? [] : this.valueUnitTwo.map(({ id }) => id)
        },
        date_from: this.dateRange[0],
        date_to: this.dateRange[1],
        department: this.department === '全て' ? null : this.department,
        select_filter_type: this.selectedDateOrYears
      }
      this.$emit('input', payload)
    },

    handleSubmitForm: throttle(function () {
      this.fireSearch()
      this.search = true
      this.$emit('get-search', this.search)
    }, 2000),

    selectAllUnitOne () {
      this.valueUnitOne = this.isSelectedAllOne ? [] : this.getAllUnitWithFilter(this.unit1Id, 1)
    },

    selectAllUnitTwo () {
      this.valueUnitTwo = this.isSelectedAllTwo ? [] : this.getAllUnitWithFilter(this.unit2Id, 2)
    },

    selectDepartment (department) {
      this.department = department
      if (this.unit1Id === 'customer') {
        this.selectUnitOne(this.unit1Id)
      } else if (this.unit2Id === 'customer') this.selectUnitTwo(this.unit2Id)
    },

    flatUnits (units = []) {
      return units.reduce((prevItem, curItem) => prevItem.concat(curItem.libs), [])
    },

    getAllUnitWithFilter (unitId, unitIndex) {
      let unitData = {
        1: {
          category: this.flatUnits(this.categoriesUnitOne),
          customer: this.flatUnits(this.customersUnitOne),
          employee: this.flatUnits(this.personInChargeOne)
        },
        2: {
          category: this.flatUnits(this.categoriesUnitTwo),
          customer: this.flatUnits(this.customersUnitTwo),
          employee: this.flatUnits(this.personInChargeTwo)
        }
      }
      if (unitData[unitIndex] && unitData[unitIndex][unitId]) {
        return unitData[unitIndex][unitId]
      }
      return []
    },

    formatUnit (data) {
      let listDataFormatted = data.reduce((prevItem, curItem) => prevItem.concat(curItem), [])
      const selectAll = { libs: listDataFormatted, name: '全て' }
      return selectAll
    },

    firstDateOfYear (year) {
      return startOfYear(new Date(`${year}`))
    },

    lastDateOfYear (year) {
      return endOfYear(new Date(`${year}`))
    },

    generateDateRangeByYear (year) {
      const currentDay = `${year}/02/01`
      const nextDay = `${year + 1}/01/31`
      return [
        currentDay,
        nextDay
      ]
    },

    selectYear (yearOption) {
      this.year = yearOption.value
      this.dateRange = this.generateDateRangeByYear(yearOption.value)
    },

    changeRevenueAndProfitFilterType () {
      if (this.selectedDateOrYears) {
        let getCurrentFilterYear = this.years.filter(year => year.value === this.year)
        this.selectYear(getCurrentFilterYear[0])
      }
    },

    translationSelectByDateOrYears () {
      return this.selectByDateOrYears.map(selectByDateOrYear => ({
        ...selectByDateOrYear,
        name: this.translations(`dashboard.${selectByDateOrYear.id}`)
      }))
    }
  }
}
</script>

<style scoped>
.dropdown-month {
  transform: translate3d(0px, 33px, 0px) !important;
}

.card-label {
  min-width: 70px;
  width: 70px;
}

.dropdown-item--disabled {
  color: #212529 !important;
  background-color: #d5d5d5;
  pointer-events: none;
}

.date-range-field {
  max-width: 215px;
  width: 100%;
}

/* Begin - custom multiselect */
.custom-multiselect >>> .multiselect__option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
}

.custom-multiselect >>> .multiselect__option--selected::after {
  position: relative;
  min-width: 84px;
}
/* End - custom multiselect */
</style>
